import { useContext, useEffect, useState } from "react";
import IOnTypeaheadLookupByTokenTypeDTO from "../../../models/DTO/IOnTypeaheadLookupByTokenTypeDTO";
import IProcessAssignedVendorsDTO from "../../../models/DTO/IProcessAssignedVendorsDTO";
import ITypeaheadLookupByTokenTypeDTO from "../../../models/DTO/ITypeaheadLookupByTokenTypeDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IOwTableCols from "../../../models/IOwTableCols";
import IRepGroup from "../../../models/IRepGroup";
import IVendorModel from "../../../models/IVendorModel";
import TokenTypesEnum from "../../../models/TokenTypesEnum";
import OwButton from "../../shared/OwButton/OwButton";
import { OwIconButton } from "../../shared/OwIconButton/OwIconButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTable from "../../shared/OwTable/OwTable";
import Typeahead from "../../shared/Typeahead/Typeahead";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import { SocketContext } from "../../../contexts/SocketContext";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import { ConfirmDeleteOverlayFn } from "../../shared/ConfirmDeleteOverlayFn/ConfirmDeleteOverlayFn";
import { OwDeleteEditActions } from "../../shared/OwDeleteEditActions/OwDeleteEditActions";

type Props = {
    repGroup: IRepGroup;
    parentRowIndex: number;
};

export const RepGroupsAssignedVendors = (props: Props) => {
    // refElem: any = null;

    const socket = useContext(SocketContext)!;
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const renderActionCol = (row: IVendorModel, index: number) => {
        return (
            <div>
                <OwDeleteEditActions
                    isEditMode={false}
                    onTrashClickFn={() => {
                        confirmDelete(row, index);
                    }}
                    onEditClickFn={() => {}}
                    hideEdit={true}
                />
            </div>
        );
    };

    const [vendors, setVendors] = useState(props.repGroup.Vendors || []);
    const [foundVendors, setFoundVendors] = useState<IVendorModel[]>([]);
    const [performingLookup, setPerformingLookup] = useState(false);
    const [selectedVendor, setSelectedVendor] = useState<IVendorModel | undefined>(undefined);
    const [columns, setColumns] = useState<IOwTableCols[]>([
        {
            title: "",
            valueProp: "",
            isActionsCol: true,
            renderFn: renderActionCol,
            renderFnEmitsRow: true,
        },
        {
            title: "name",
            valueProp: "name",
        },
        {
            title: "email",
            valueProp: "email",
        },
        {
            title: "customer_internal_id",
            valueProp: "customer_internal_id",
        },
    ]);
    const [sourceElem, setSourceElem] = useState<HTMLElement | null>(null);
    const [sourceElemId, setSourceElemId] = useState<string>("");
    const [sourceVendor, setSourceVendor] = useState<IVendorModel | undefined>(undefined);
    const [lookupName, setLookupName] = useState("");

    const vendorLookup = (name: string) => {
        setLookupName(name);
        setPerformingLookup(true);
    };

    const lookupByTokenType = () => {
        const payload: ITypeaheadLookupByTokenTypeDTO = {
            name: lookupName,
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            tokenType: TokenTypesEnum.SUPPLIER_VENDOR,
            limit: 100,
        };

        socket.emit(EndpointsEnum.TokenTypeaheadLookupByTokenType, payload);
    };

    const onVendorLookup = (data: IOnTypeaheadLookupByTokenTypeDTO) => {
        if (performingLookup) {
            const _foundVendors = data.results.map((token) => {
                return token.Vendor!;
            });

            setFoundVendors(_foundVendors);
            setPerformingLookup(false);
        }
    };

    // We have to do it this way because the socket initialization maintains the old value for the performingLookup state
    useEffect(() => {
        socket.removeListener(EndpointsEnum.TokenOnTypeaheadLookupByTokenType, onVendorLookup);
        socket.on(EndpointsEnum.TokenOnTypeaheadLookupByTokenType, onVendorLookup);

        lookupByTokenType();
    }, [performingLookup]);

    const selectVendor = (vendor: IVendorModel) => {
        setSelectedVendor(vendor);
    };

    const addVendor = () => {
        if (selectedVendor) {
            const payload: IProcessAssignedVendorsDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                repGroupGuid: props.repGroup.guid,
                vendorGuids: [selectedVendor.guid],
            };

            socket.emit(EndpointsEnum.RepGroupProcessAssignedVendors, payload);
            setPerformingLookup(true);
        }
    };

    const onProcessAssignedVendors = () => {
        if (performingLookup) {
            setPerformingLookup(false);
        }
    };

    const sockets: IUiSocketSetup[] = [
        { endpoint: EndpointsEnum.TokenOnTypeaheadLookupByTokenType, fn: onVendorLookup },
        { endpoint: EndpointsEnum.RepGroupOnProcessAssignedVendors, fn: onProcessAssignedVendors },
    ];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        return () => {
            for (const _socket of sockets) {
                socket.removeListener(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    const confirmDelete = (row: IVendorModel, index: number) => {
        const elem = document.getElementById(`vendorRow-${props.parentRowIndex}-${index}`);

        if (elem) {
            console.log("elem: ");
            console.log(elem.offsetHeight, elem.offsetTop, elem.scrollTop, elem.scrollHeight);

            setSourceElem(elem);
            setSourceVendor(row);
            setSourceElemId(`vendorRow-${props.parentRowIndex}-${index}`);
        }
    };

    const cancelDelete = () => {
        setSourceElem(null);
        setSourceElemId("");
        setSourceVendor(undefined);
    };

    const commitDelete = () => {
        if (sourceVendor) {
            const payload: IProcessAssignedVendorsDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                repGroupGuid: props.repGroup.guid,
                vendorGuids: [sourceVendor.guid],
                deleteFlag: true,
            };

            socket.emit(EndpointsEnum.RepGroupProcessAssignedVendors, payload);

            setPerformingLookup(true);
            setSourceElem(null);
            setSourceElemId("");
            setSourceVendor(undefined);
        }
    };

    const renderFoundVendorsVn = (vendor: IVendorModel) => {
        return (
            <div>
                <div>{vendor.name}</div>
                <div className={"text-small text-muted"}>{vendor.email}</div>
                <div className={"text-small text-warning"}>{vendor.customer_internal_id}</div>
            </div>
        );
    };

    return (
        <div className={"RepGroupsAssignedVendors"}>
            <div className="row">
                <div className={"col-12"}>
                    <OwLabel title={"vendors"} isSupplierVendorOverride={true} supplierModel={supplierModel} /> ({vendors.length})
                    <div className={"d-flex mb-2"}>
                        <Typeahead
                            outerWrapperClassName={"w-20r"}
                            isSelectableFn={() => {
                                return true;
                            }}
                            typeaheadApiFn={vendorLookup}
                            typeaheadItems={foundVendors}
                            itemsRenderFn={renderFoundVendorsVn}
                            titleProp={""}
                            subTitleProp={""}
                            selectedItem={selectedVendor}
                            selectedItemTitleProp={"name"}
                            selectedItemFn={selectVendor}
                            maxResults={100}
                            scrollableList={true}
                        />
                        <div className={"ms-2"}>
                            <OwButton title={"add"} leftIconClass={"fas fa-plus"} fn={addVendor} />
                        </div>
                    </div>
                </div>

                <div className="col-12 position-relative">
                    <ConfirmDeleteOverlayFn
                        targetElem={sourceElemId}
                        handleConfirm={commitDelete}
                        handleCancel={cancelDelete}
                        leftAdjustment={-12}
                        skipMainView={true}
                        nestedParentElem={`rep-group-vendors-${props.parentRowIndex}`}
                    />

                    <OwTable
                        id={`rep-group-vendors-${props.parentRowIndex}`}
                        rowIdName={`vendorRow`}
                        parentRowIndex={props.parentRowIndex}
                        columns={columns}
                        dataSet={vendors}
                        userModel={userModel}
                        supplierModel={supplierModel}
                        dataFetch={false}
                        initialData={false}
                        isDetailViewTable={true}
                    />
                </div>
            </div>
        </div>
    );
};
